import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { viewAllAllocatedRequestService } from './viewallallocatedrequest.service';
import { global } from '../../shared/global';
import { FeesIncrease } from '../Models/updatependingrequest.model'
declare var $: any;

@Component({
  selector: 'app-viewallallocatedrequest',
  templateUrl: './viewallallocatedrequest.component.html',
  styleUrls: ['./viewallallocatedrequest.component.css']
})
export class ViewallallocatedrequestComponent implements OnInit {
  @ViewChild('allocatereq') allocatereq: NgForm;
  searchtext;
  isDesc: boolean;
  column: string;
  FeesIncreaseList: Array<any>;
  FeesIncreaseDetail: Array<any>;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  data: FeesIncrease;
  dropDownData:any;
  boards:any;
  mediums:any;
  stds:any;
  years:any;
  totalAmt: any;
  SchoolName: any;
  Medium: any;
  AcademicYear: any;
  Standard: any;
  InstituteType: any;
  CourseYear: any;
  totalPages = 10;
  totalAllocateReq: any;

  constructor(private service: viewAllAllocatedRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.getAllocatedFeesList(this.p);
});
    this.fillMedium();
    this.fillStd();
    this.fillAcademicYear();
    //this.getAllocatedFeesList();
    $("#searchtext").val("");
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#fromDate').attr('max',  maxDate);
    $('#toDate').attr('max',  maxDate);
  }

  fillMedium() {
    const data = {
      //HashCode: this.HashCode
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.allocatereq.controls['MediumID'].setValue('0');
      });
  }

  fillStd() {
    const data = {
      //HashCode: this.HashCode
    };
    this.service.fillStandard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.stds = this.dropDownData.dropdownlist;
        this.allocatereq.controls['StandardID'].setValue('0');
      });
  }

  fillAcademicYear() {
    const data = {
      //registrationID: localStorage.getItem("userID")
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.allocatereq.controls['AcademicYearID'].setValue(this.years.length);
      });
  }

  getAllocatedFeesList(page) {
    var frmdate = $('#fromDate').val()
    var todate = $('#toDate').val()
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }

    if(frmdate != null && todate != null){
      if(new Date(frmdate) > new Date(todate)){
        this.toastr.error("From Date must be less then To Date");
        return
      }
    }
    this.spinner.show();
    const data = {
      HashCode: "",
      AcademicYearID: $('#AcademicYearID').val(),
      MediumID: $('#MediumID').val(),
      StandardID: $('#StandardID').val(),
      YearID : localStorage.getItem("YearID"),
      FromDate: $('#fromDate').val(),
      ToDate: $('#toDate').val(),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    };
    
    this.service.getAllocatedFeesList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.FeesIncreaseList = undefined;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
        //  this.router.navigate(['/aciadmin']);
          return;
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.show();
          this.FeesIncreaseList = this.responseData.AllocatedFeesList;
         // this.totalPages = this.responseData.totalPages;
          this.totalAllocateReq = this.responseData.totalCount;
          this.spinner.hide();
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  viewFeesDetail(i){
    $('#detailModal').modal('show');
    this.FeesIncreaseDetail =  this.FeesIncreaseList[i]["AllocatedFeesDetail"];
    this.SchoolName =  this.FeesIncreaseList[i]["SchoolName"];
    this.Medium =  this.FeesIncreaseList[i]["SchoolName"];
    this.AcademicYear =  this.FeesIncreaseList[i]["AcademicYear"];
    this.Standard =  this.FeesIncreaseList[i]["Standard"];
    this.InstituteType =  this.FeesIncreaseList[i]["InstituteType"];
    this.CourseYear=  this.FeesIncreaseList[i]["CourseYear"];
    this.totalAmt = this.FeesIncreaseList[i]["TotalAmount"];
  }
  
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.FeesIncreaseList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }

  closeForm() {
    $('#detailModal').modal('hide');
  }

  reset(){
    $('#AcademicYearID').val(this.years.length);
    $('#MediumID').val(0);
    $('#StandardID').val(0);
    $('#fromDate').val('');
    $('#toDate').val('');
    this.getAllocatedFeesList(this.p);
  }
}
